
export default {
  name: 'VsCarouselSlide',
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      active: false,
      inView: false
    }
  },
  computed: {
    attrs() {
      return {
        items: 'stretch',
        justify: 'stretch',
        shrink: false,
        grow: true
      }
    }
  }
}
